import {productionStepQueryKeys} from '../production-step-query-keys';
import {useQueryClient} from '@tanstack/react-query';
import {ProductionStepProp} from './production-step.models';

export function useProductionStepMaterialListInvalidation(props: ProductionStepProp): { invalidateList: () => void } {
  const queryClient = useQueryClient();
  const invalidateList: () => void = async () => {
    await queryClient.invalidateQueries({
      queryKey: productionStepQueryKeys.materialConditionsList(props.productionStepId),
    });
  };
  return {invalidateList};
}
